'use strict';

exports.__esModule = true;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.getAll = getAll;
exports.create = create;
exports.createPair = createPair;
exports.update = update;
exports.remove = remove;

var _quCheck = require('../utils/qu-check');

var _apiCheck = require('api-check');

var _apiCheck2 = _interopRequireDefault(_apiCheck);

var _http = require('../network/http');

var _http2 = _interopRequireDefault(_http);

var _modelProvider = require('../model-provider');

var _modelProvider2 = _interopRequireDefault(_modelProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getAll: getAll,
  create: create,
  createPair: createPair,
  update: update,
  remove: remove

  /**
   * Get all waypoints of a job
   * @param {Object} attrs - Attributes
   * @param {string} [attrs.jobId] - order number associated with the job
   * @returns {promise} containing the entity array of waypoints
   */
};
function getAll() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var jobId = attrs.jobId,
      orderNumber = attrs.orderNumber;

  _quCheck.checker.warn(_quCheck.common.jobId, jobId);

  return _http2.default.get('/customer/jobs/' + (jobId || orderNumber) + '/waypoints').then(function (results) {
    return results.map(function (waypoint) {
      return _modelProvider2.default.Waypoint(waypoint, { jobId: jobId });
    });
  });
}

/**
 * Add a waypoint to a job
 * @param {Object} attrs - Attributes
 * @param {string} [attrs.jobId] - order number associated with the job
 * @param {number} [attrs.orderId] - id of the order associated with the job
 * @param {Object} [attrs.waypoint - Waypoint object
 * @param {number} [attrs.waypoint.locationId - id of the location associated with the job
 * @param {string} [attrs.waypoint.waypointType] - 'pickup' or 'dropoff'
 * @param {string} [attrs.waypoint.scheduledFor] - ISO datetime for waypoint start
 * @param {string} [attrs.waypoint.notes] - free text displayed for the waypoint
 * @returns {promise} containing the entity object of the waypoint
 */
function create() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var jobId = attrs.jobId,
      orderNumber = attrs.orderNumber,
      waypoint = attrs.waypoint;

  _quCheck.checker.warn(_quCheck.common.jobId, jobId);

  return _http2.default.post('/customer/jobs/' + (jobId || orderNumber) + '/waypoints', waypoint).then(function (waypointObj) {
    return _modelProvider2.default.Waypoint(waypointObj, { jobId: jobId });
  });
}

/**
 * Add pickup and dropoff
 * @param {Object} attrs - similar as in addWaypoint (waypointType is overwritting)
 */
function createPair() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var jobId = attrs.jobId,
      _attrs$waypoint = attrs.waypoint,
      waypoint = _attrs$waypoint === undefined ? {} : _attrs$waypoint;

  var waypoints = [(0, _extends3.default)({}, waypoint, { waypointType: 'pickup' }), (0, _extends3.default)({}, waypoint, { waypointType: 'dropoff' })];
  _quCheck.checker.warn(_quCheck.common.jobId, jobId);

  return _promise2.default.all(waypoints.map(function (waypointObj) {
    return create({ jobId: jobId, waypoint: waypointObj });
  }));
}

function update() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var jobId = attrs.jobId,
      _attrs$waypoint2 = attrs.waypoint,
      waypoint = _attrs$waypoint2 === undefined ? {} : _attrs$waypoint2;
  var id = waypoint.id,
      waypointAttrs = (0, _objectWithoutProperties3.default)(waypoint, ['id']);

  _quCheck.checker.warn(_quCheck.common.jobId, jobId);
  _apiCheck2.default.number(id);

  return _http2.default.put('/customer/jobs/' + jobId + '/waypoints/' + id, waypointAttrs).then(function (waypointObj) {
    return _modelProvider2.default.Waypoint(waypointObj, { jobId: jobId });
  });
}

function remove() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var jobId = attrs.jobId,
      id = attrs.id;

  _quCheck.checker.warn(_quCheck.common.jobId, jobId);
  _apiCheck2.default.number(id);

  return _http2.default.remove('/customer/jobs/' + jobId + '/waypoints/' + id);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/customer/waypoints.js
// module id = 181
// module chunks = 0